import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointService } from '../../breakpoint.service';
import { RxLet } from '@rx-angular/template/let';
import { MatToolbarModule } from '@angular/material/toolbar';

@Component({
  selector: 'thred-dashboard-shell',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    RxLet,
    MatToolbarModule,
  ],
  templateUrl: './dashboard-shell.component.html',
  styleUrls: ['./dashboard-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardShellComponent {
  constructor(
    public bp: BreakpointService,
    @Optional()
    @Inject('HIDE_TOOLBAR')
    public hideToolbar?: boolean | undefined,
  ) {}
}
